module.exports = __webpack_public_path__ + "media/images/procedure_managements/how_to_create/img_mobile_1-eded8c0fb4c9ab10ff0841e3c99eb72d.png";